import React from 'react'

import type { AgentChatMessage } from '~/api/agentChat'

import { MessageAttachment } from './MessageAttachment'
import { MessageBubble } from './MessageBubble'

import styles from './ChatMessage.module.scss'

interface UserMessageBubbleProps {
  message: AgentChatMessage
}

export const UserMessageBubble: React.FC<UserMessageBubbleProps> = ({
  message,
}) => (
  <MessageBubble sender="user">
    {message.content}
    {message.attachments?.map((attachment, idx) => (
      <MessageAttachment
        attachment={attachment}
        // eslint-disable-next-line react/no-array-index-key
        key={`${message.id}-${attachment.mimeType}-${idx}`}
      />
    ))}
    <div className={styles.messageTimestamp}>{message.timestamp}</div>
  </MessageBubble>
)

export default UserMessageBubble
